module.exports = __webpack_public_path__ + "static/assets/56aa93746e6b98ce46012cb375cd960e.svg";